/* eslint-disable max-len */
import React from 'react';

import Icon from 'editor/src/component/Icon/index';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

// Fill-the-sheet-with-copies icon, drawn in the style of IconFill: the sheet outline
// with a grid of repeated pieces inside.
function IconFillSheet({ className }: Props) {
  return (
    <Icon className={className}>
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17 1H1V15H17V1Z" strokeWidth="0.5" strokeLinecap="round" />
        <path d="M8 3.5H3.5V7H8V3.5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.5 3.5H10V7H14.5V3.5Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8 9H3.5V12.5H8V9Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.5 9H10V12.5H14.5V9Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </Icon>
  );
}

export default IconFillSheet;
